module.exports = __webpack_public_path__ + "img/dj.svg";